<script>
export default {
    props: {
        title: {
            type: String,
            default: 'Confirmation'  // Default title
        }
    },
    data() {
        return {
            dynamicTitle: '',
            message: '',
            confirmedCallback: null,
            show: false,
        };
    },
    methods: {
        showModal(message, confirmedCallback, title = null) {
            this.message = message;
            this.confirmedCallback = confirmedCallback;
            this.show = true;

            this.dynamicTitle = title || this.title;
        },

        closeModal() {
            this.show = false;
        }
    }
}
</script>

<template>
    <b-modal v-model="show">
        <template #modal-title>
            <span :style="dynamicTitle === 'WARNING' ? 'color: red;' : ''">
                {{ dynamicTitle }}
            </span>
        </template>
        <template #modal-footer>
            <button type="button" class="btn" v-on:click="closeModal">Cancel</button>
            <button type="button" class="btn btn-primary" v-on:click="confirmedCallback">Confirm</button>
        </template>
        <div>
            <p>{{ message }}</p>
        </div>
        <!-- /.modal-dialog -->
    </b-modal>
    <!-- /.modal -->
</template>